// extracted by mini-css-extract-plugin
module.exports = {"warning":"WaitlistClient_warning__YsfFu","warning__icon":"WaitlistClient_warning__icon__2fHPt"};